module.exports = require("././ui-utils.js");


//////////////////
// WEBPACK FOOTER
// angular-ui-utils (bower component)
// module id = 399
// module chunks = 1